import styled from "styled-components";

export const ColorWrapper = styled.div`
  p,
  div,
  span {
    color: ${({ theme, color }) => color || theme.text.input} !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ alignment }) => alignment};
  padding-left: ${({ paddingLeft }) => `${paddingLeft}px`};
  padding-right: ${({ paddingRight }) => `${paddingRight}px`};

  #text-editor .ql-editor * {
    font-size: ${({ textSize }) => textSize}px;
  }
  #title-editor .ql-editor * {
    font-size: ${({ titleSize }) => titleSize}px;
  }
  #overline-editor .ql-editor * {
    font-size: ${({ overlineSize }) => overlineSize}px;
  }

  #title-editor {
    .ql-editor {
      font-weight: 500;
      padding: 0px 1px;
    }
  }

  .quill .ql-editor {
    text-align: ${({ textAlign }) => textAlign};
  }
`;

export const IconPreview = styled.div`
  /* height: ${({ iconSize }) => `${iconSize}px`}; */

  svg {
    color: ${({ color }) => color};
    height: ${({ iconSize }) => `${iconSize}px`};
    width: ${({ iconSize }) => `${iconSize}px`};
  }
`;

export const Line = styled.div`
  height: ${({ lineWeight }) => lineWeight}px;
  width: ${({ lineWidth }) => lineWidth}%;
  background-color: ${({ lineColor }) => lineColor};
  border-radius: 2px;
  margin: 8px 0px;
`;

export const OverlinePreview = styled.span`
  color: ${({ overlineColor }) => overlineColor};
  font-size: ${({ overlineSize }) => overlineSize}px;
  text-align: ${({ alignment }) => alignment};
  padding: 3.6px 0px;
  p {
    margin: 0px;
  }
`;

export const TitlePreview = styled.span`
  color: ${({ titleColor }) => titleColor};
  font-size: ${({ titleSize }) => titleSize}px;
  font-weight: ${({ titleBold }) => (titleBold ? "800" : "500")};
  text-align: ${({ alignment }) => alignment};
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  padding: 7.6px 0px;
  p {
    margin: 0px;
  }
`;

export const TextPreview = styled.div`
  font-size: ${({ textSize }) => textSize}px;
  text-align: ${({ alignment }) => alignment};
  margin-top: 6px;
  margin-bottom: 6px;

  p {
    margin: 0px;
  }
`;
